import { Form } from 'antd/lib';
import { usePairingContext } from 'hooks/usePairingContext';

export function usePairingFormHandler() {
	const [form] = Form.useForm();
	const { setPairingData, ...pairing } = usePairingContext();

	const onDataChange = (dataKey: string, value: string) => {
		setPairingData((prevPairing) => ({
			...prevPairing,
			[dataKey]: value,
		}));
	};

	const inputHandler = ({
		dataKey,
		value,
	}: {
		dataKey: string;
		value: string;
	}) => {
		onDataChange(dataKey, value);
	};

	return {
		form,
		inputHandler,
		setPairingData,
		...pairing,
	};
}
